import { Button, Center, Image, Progress, Stack, Text } from '@mantine/core';
import type { FC } from 'react';

interface ImageUploadProgressProps {
  previewSrc: string;
  progress: number;
  error: string | null;
  onRetry: () => void;
}

export const ImageUploadProgress: FC<ImageUploadProgressProps> = ({ previewSrc, progress, error, onRetry }) => {
  return (
    <Center h="100%" p="xl" style={{ flex: 1 }}>
      <Stack align="center" gap="sm" maw={300}>
        <Image alt="Uploading artwork" radius="md" src={previewSrc} style={{ opacity: error ? 0.4 : 0.6 }} w={200} />

        {error ? (
          <>
            <Text c="red.4" fw={500} size="sm" ta="center">
              {error}
            </Text>
            <Button color="gray.6" radius="xl" variant="outline" onClick={onRetry}>
              Try again
            </Button>
          </>
        ) : (
          <>
            <Progress
              aria-label="Upload progress"
              aria-valuemax={100}
              aria-valuemin={0}
              aria-valuenow={progress}
              color="blue.5"
              radius="xl"
              size="sm"
              value={progress}
              w="100%"
            />
            <Text c="dimmed" size="sm">
              Uploading your artwork... {progress}%
            </Text>
          </>
        )}
      </Stack>
    </Center>
  );
};
